/** Forma canónica de inventario_muebles (PWA / ficha / encargo). */

export function newInventarioItemId() {
  return globalThis.crypto?.randomUUID?.() || `id-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function ensureInventarioMueblesShape(raw) {
  if (!raw || !Array.isArray(raw.estancias)) return null;
  return {
    version: raw.version || 1,
    generado_en: raw.generado_en || null,
    editado_en: raw.editado_en || null,
    editado_por: raw.editado_por || null,
    estancias: raw.estancias.map((est, i) => ({
      id: est.id || newInventarioItemId(),
      nombre: String(est.nombre || `Estancia ${i + 1}`).trim(),
      items: (est.items || []).map((it) => {
        if (typeof it === "string") {
          const t = it.trim();
          if (!t) return null;
          return { id: newInventarioItemId(), texto: t, marcado: true, esManual: false };
        }
        return {
          id: it.id || newInventarioItemId(),
          texto: String(it.texto ?? "").trim(),
          marcado: it.marcado !== false,
          esManual: !!it.esManual,
        };
      }).filter(Boolean),
    })),
  };
}

export function inventarioMueblesTieneLineas(inv) {
  const shaped = ensureInventarioMueblesShape(inv);
  if (!shaped) return false;
  return shaped.estancias.some((e) => Array.isArray(e.items) && e.items.length > 0);
}
